import { useContext, useEffect, useCallback } from 'react';
import {
  checkForSecureWrapper,
  registerEvents,
  removeEventListeners,
} from '../../scripts/secure-wrapper/enforceSecureWrapper';
import { KioskContext } from '../../context/KioskProviderContext';
import { AssessmentContext } from '../../context/AssessmentContext';
import { Observable } from '../../scripts/common/Observable';
import { saveAndExitTestTaker } from '../../scripts/learnosityScripts';

//wait is true, so notify runs synchronously.
//priority on subscribe will call the methods in priority order
//otherwise it will get invoked in the order of subscription
export const SecureWrapperObservable = new Observable(
  'secureWrapperEvent',
  true,
);

/**
 * Bridges the MacOS/iOS secure wrapper events to the PWA. Rendered on every
 * route(see Layout) because the wrapper can ask us to exit at any point, not
 * just while a test is in progress.
 */
const SecureWrapper = () => {
  //Layout renders this outside of the AssessmentProvider on login/landing, so
  //learnosityItemApp is undefined until the tester is actually in a test.
  const { learnosityItemApp } = useContext(AssessmentContext);
  const { isSecure, platform, displayMode } = useContext(KioskContext);

  const emitEvent = useCallback((event) => {
    SecureWrapperObservable.notify({ ...event });
  }, []);

  //Saves the test before exiting. Only used once we have an item app to save.
  //timedExit is false - the wrapper is already on its way out, so there is no
  //point showing the tester a countdown dialog they would have to close.
  const exitCallback = useCallback(() => {
    saveAndExitTestTaker(learnosityItemApp, emitEvent, false);
  },[emitEvent, learnosityItemApp]);

  useEffect(() => {
    //Only register when isSecure is true and it is for the macos use case
    if (!isSecure || !checkForSecureWrapper(platform, displayMode)) {
      return;
    }

    //No item app means there is nothing to save(login/landing/pre-test), leaving
    //the callback undefined tells exitHandler to exit the wrapper straight away.
    let callback = learnosityItemApp ? exitCallback : undefined;
    //Re-registered whenever learnosityItemApp changes so the handler always
    //saves against the current item app. The cleanup keeps this to a single
    //set of event handlers.
    const eventHandlers = registerEvents(callback);
    return () => removeEventListeners(eventHandlers);
  }, [learnosityItemApp, isSecure, platform, displayMode, exitCallback]);

  return null;
};

export default SecureWrapper;
